export default {
  state: {
    agentStore: null,
    storeSetting: {},
  },
  mutations: {
    UPDATE_AGENT_STORE(state, n) {
      state.agentStore = n
    },
    UPDATE_STORE_SETTING(state, n) {
      state.storeSetting = n
    },
  },
}
